/* Glide slider */
import Glide from '@glidejs/glide';

class ProfetSlider {
	constructor() {}
	init() {
		this.setupClientLogosSlider();
		this.setupContentBoxesSlider();
		this.setupReferencesSlider();
	}
	setupClientLogosSlider() {
		const config = {
			type: 'carousel',
			autoplay: 4000,
			//peek: 0,
			perView: 2,
			animationDuration: 500,
			gap: 15,
		};

		let slider = document.querySelector('.client-logos-slider');
		if (!slider) {
			return;
		}
		let glide = new Glide('.client-logos-slider', config).mount();
	}
	setupContentBoxesSlider() {
		const config = {
			//type: 'carousel',
			//autoplay: 4000,
			//peek: 0,
			//perView: 2,
			animationDuration: 500,
			//gap: 15,
		};

		let sliders = document.querySelectorAll('.content-boxes-slider');
		if (!sliders) {
			return;
		}
		sliders.forEach((slider) => {
			let glide = new Glide(slider, config).mount();
		});
	}
	setupReferencesSlider() {
		const config = {
			//type: 'carousel',
			autoplay: 4000,
			peek: 0,
			//perView: 2,
			animationDuration: 500,
			gap: 15,
		};

		let slider = document.querySelector('.references-slider');
		if (!slider) {
			return;
		}
		let glide = new Glide('.references-slider', config).mount();

		let prevButton = document.querySelector('.references-slider-wrapper .references-slider-prev');
		if (prevButton) {
			prevButton.addEventListener('click', function(event) {
				event.preventDefault();
				glide.go('<');
			});
		}
		let nextButton = document.querySelector('.references-slider-wrapper .references-slider-next');
		if (nextButton) {
			nextButton.addEventListener('click', function(event) {
				event.preventDefault();
				glide.go('>');
			});
		}
	}
}
window.addEventListener('load', () => {
	window.ProfetSlider = new ProfetSlider();
	window.ProfetSlider.init();
});
